import logger from '../../utils/logger';
import React from 'react';
import { Check, Loader2, X } from 'lucide-react';
import { useNotifications } from '../../contexts/NotificationsContext';
import { useNavigate } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';

const NotificationsDropdown = ({ onClose }) => {
    const { notifications, loading, markAsRead, markAllAsRead } = useNotifications();
    const navigate = useNavigate();

    const handleMarkAsRead = async (id) => {
        await markAsRead(id);
    };

    const handleMarkAllAsRead = async () => {
        await markAllAsRead();
    };

    const handleNotificationClick = (notification) => {
        if (!notification.read) {
            markAsRead(notification.id);
        }
        if (notification.link) {
            onClose();
            navigate(notification.link);
        }
    };

    if (loading) {
        return (
            <div className="absolute top-full right-0 mt-1 w-96 bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 py-2 px-3 shadow-xl">
                <div className="flex items-center justify-center py-4">
                    <Loader2 className="animate-spin text-gray-400 dark:text-gray-500" size={24} />
                </div>
            </div>
        );
    }

    return (
        <div className="absolute top-full right-0 mt-1 w-96 bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 max-h-[32rem] overflow-hidden flex flex-col shadow-xl">
            <div className="p-3 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between bg-gray-50 dark:bg-gray-800">
                <h3 className="font-medium text-gray-900 dark:text-gray-100">Notifications</h3>
                <div className="flex items-center gap-2">
                    <button
                        onClick={handleMarkAllAsRead}
                        className="text-xs text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300"
                    >
                        Mark all as read
                    </button>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-500 dark:text-gray-500 dark:hover:text-gray-400"
                    >
                        <X size={16} />
                    </button>
                </div>
            </div>

            <div className="overflow-y-auto flex-1">
                {notifications.length === 0 ? (
                    <div className="p-4 text-center text-gray-500 dark:text-gray-400">
                        No notifications
                    </div>
                ) : (
                    notifications.map((notification) => (
                        <div
                            key={notification.id}
                            onClick={() => handleNotificationClick(notification)}
                            className={`p-3 border-b border-gray-100 dark:border-gray-700/50 last:border-0 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors ${
                                !notification.read ? 'bg-blue-50 dark:bg-blue-950/40' : ''
                            } ${notification.link ? 'cursor-pointer' : ''}`}
                        >
                            <div className="flex items-start justify-between gap-2">
                                <div className="flex-1 min-w-0">
                                    {notification.title && (
                                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">
                                            {notification.title}
                                        </p>
                                    )}
                                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-0.5">
                                        {notification.message}
                                    </p>
                                    <p className="text-xs text-gray-500 dark:text-gray-500 mt-1">
                                        {formatDistanceToNow(new Date(notification.createdAt), { addSuffix: true })}
                                    </p>
                                </div>
                                {!notification.read && (
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleMarkAsRead(notification.id);
                                        }}
                                        className="text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 flex-shrink-0"
                                        title="Mark as read"
                                    >
                                        <Check size={16} />
                                    </button>
                                )}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default NotificationsDropdown;
